var map = {
	"./fifa22/ranks/rank_1.png": 777,
	"./fifa22/ranks/rank_10.png": 778,
	"./fifa22/ranks/rank_11.png": 779,
	"./fifa22/ranks/rank_2.png": 780,
	"./fifa22/ranks/rank_3.png": 781,
	"./fifa22/ranks/rank_4.png": 782,
	"./fifa22/ranks/rank_5.png": 783,
	"./fifa22/ranks/rank_6.png": 784,
	"./fifa22/ranks/rank_7.png": 785,
	"./fifa22/ranks/rank_8.png": 786,
	"./fifa22/ranks/rank_9.png": 787
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 320;